import { BrandAndMarketListItem, GuidIdAndLabel, CodeAndLabel } from '../../../integrated-client/models';
import { DEFAULT_PAGE_SIZE } from '../../../utils/Constants';

export interface IAutocompleteObject {
  id: string;
  code: string;
  label: string;
}

export interface IFiltersData {
  brandAndMarket?: BrandAndMarketListItem | null;
  supplier?: GuidIdAndLabel | null;
  carrier?: CodeAndLabel | null;
  showDeleted?: boolean;
  showDisabled?: boolean;
  relevance?: number;
  offset: number;
  limit: number;
}

export class FiltersData implements IFiltersData {
  brandAndMarket?: BrandAndMarketListItem | null;
  supplier?: GuidIdAndLabel | null;
  carrier?: CodeAndLabel | null;
  showDeleted?: boolean;
  showDisabled?: boolean;
  relevance?: number;
  offset: number;
  limit: number;

  constructor() {
    this.offset = 0;
    this.limit = DEFAULT_PAGE_SIZE;
  }
}
